import React from 'react';
import { Link } from 'react-router-dom';
import S from './style';
import TranslateStatic from '../../locales/TranslateStatic';

import YumurtlamaImg from '../../assets/endoskopik.jpeg';
import AsrmEshre from '../../components/asrmEshre';

export function Endoskopik() {
  return (
    <S.PageWrapper>
      <S.HeroSection>
        <div className="hero-content">
          <h1><TranslateStatic string="endoskopik ameliyatlar" /></h1>
          <S.Breadcrumb>
            <Link to="/"><TranslateStatic string="home" /></Link>
            <span className="separator">/</span>
            <TranslateStatic string="endoskopik ameliyatlar" />
          </S.Breadcrumb>
        </div>
      </S.HeroSection>

      <S.ContentWrapper>
        <div className="info-container">
          <div className="image-wrapper">
            <img src={YumurtlamaImg} alt="Endoskopik Ameliyatlar" />
          </div>

          <div className="date-info">
            <TranslateStatic string="SonGuncellemeTarihi" /> 19.02.2025
          </div>

          <div className="text-content">
            <p>
              <TranslateStatic string="endoskopikP1" />
            </p>
            <h3><TranslateStatic string="endoskopikH1" /></h3>
            <p>
              <TranslateStatic string="endoskopikP2" />
            </p>
            <ul>
              <li><TranslateStatic string="endoskopikLi1" /></li>
              <li><TranslateStatic string="endoskopikLi2" /></li>
              <li><TranslateStatic string="endoskopikLi3" /></li>
              <li><TranslateStatic string="endoskopikLi4" /></li>
              <li><TranslateStatic string="endoskopikLi5" /></li>
              <li><TranslateStatic string="endoskopikLi6" /></li>
            </ul>
            <p>
              <TranslateStatic string="endoskopikP6" />
            </p>
            <h3><TranslateStatic string="endoskopikH2" /></h3>
            <p>
              <TranslateStatic string="endoskopikP3" />
            </p>
            <ul>
              <li><TranslateStatic string="endoskopikLi7" /></li>
              <li><TranslateStatic string="endoskopikLi8" /></li>
              <li><TranslateStatic string="endoskopikLi9" /></li>
              <li><TranslateStatic string="endoskopikLi10" /></li>
            </ul>
            <p>
              <TranslateStatic string="endoskopikNot" />
            </p>
          </div>
        </div>

        <AsrmEshre />
      </S.ContentWrapper>
    </S.PageWrapper>
  );
}
